import React from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useTheme } from '../../contexts/ThemeContext';
import Sidebar from './Sidebar';
import Header from './Header';
import LoadingSpinner from '../ui/LoadingSpinner';
import SubscriptionPaywall, { EF_PRODUCTS } from '../billing/SubscriptionPaywall';

export default function AppLayout() {
  const { isAuthenticated, isLoading, user, getIdToken } = useAuth();
  const { sidebarCollapsed } = useTheme();

  // Show loading spinner while checking authentication
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <LoadingSpinner size="lg" />
      </div>
    );
  }

  // Redirect to landing page if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return (
    <SubscriptionPaywall
      product={EF_PRODUCTS['ef-projex']}
      getAuthToken={async () => {
        if (getIdToken) return await getIdToken();
        if (user?.getIdToken) return await user.getIdToken();
        return null;
      }}
      userId={user?.uid}
    >
      <div className="min-h-screen bg-gray-50 flex">
        {/* Sidebar */}
        <Sidebar />
        
        {/* Main Content Area */}
        <div 
          className={`flex-1 flex flex-col transition-all duration-300 ${
            sidebarCollapsed ? 'ml-16' : 'ml-64'
          }`}
        >
          {/* Header */}
          <Header />
          
          {/* Page Content */}
          <main className="flex-1 overflow-auto">
            <div className="p-6">
              <Outlet />
            </div>
          </main>
        </div>
      </div>
    </SubscriptionPaywall>
  );
}
